import { createContext, useContext } from "react";

// Present when the chat sits in a docked column that can be closed, so the chat header can offer it.
const DockedChatCloseContext = createContext<(() => void) | null>(null);

export const DockedChatCloseProvider = DockedChatCloseContext.Provider;

export function useDockedChatClose() {
  return useContext(DockedChatCloseContext);
}
